import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import UpdatePopUp from "../BaladiyaUpdate/UpdatePopUp";
import { setAppError } from "../../../../../store/userSlice";
import RemoveBaladiyaPopUp from "./RemoveBaladiyaPopUp";

export default function ListBaladiyaRenewal({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
  setIndex,
  searchWords,
  setSearchWords,
}) {
  // console.log(list);

  const [filteredData, setFilteredData] = useState([]);

  const [checkedItems, setCheckedItems] = useState({});
  const [listData, SetListData] = useState([]);

  const [Popup, setPopUp] = useState(false);
  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;

    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true;
      } else {
        delete nextState[employee_id];
      }
      return nextState;
    });

    SetListData((prevItemList) => {
      const updatedList = Array.isArray(prevItemList)
        ? prevItemList.filter((item) => item !== filteredData)
        : [];
      if (isChecked) {
        updatedList.push(filteredData);
      }
      return updatedList;
    });

    // If any checkbox is unchecked, uncheck the "Select All" checkbox
    if (!isChecked) {
      setSelectAll(false);
    } else if (Object.keys(checkedItems).length + 1 === filteredData.length) {
      // If all checkboxes are checked, mark "Select All" as checked
      setSelectAll(true);
    }
  };

  //filter
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const dispatch = useDispatch();
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    const newCheckedItems = {};
    if (isChecked) {
      filteredData.forEach((item) => {
        newCheckedItems[item.employee_id] = true;
      });
    }
    setCheckedItems(newCheckedItems);
    SetListData(isChecked ? [...filteredData] : []);
  };

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectedStatus(clientStatus);
    setSelectAll(false);
    SetListData([]);
    setCheckedItems({});
    if (!clientStatus && !selectVisaProvider) {
      // setFiltered([]);
      return;
    }
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Visa Provider:", visaProvider);
    setSelectVisaProvider(visaProvider);
    setSelectAll(false);
    SetListData([]);
    setCheckedItems({});

    if (!selectedStatus && !visaProvider) {
      // setFiltered([]);
      return;
    }
  };


  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list || []);



  useEffect(() => {
    const filteredList = currentList.filter((data) => {
      if (selectedStatus && selectVisaProvider) {
        return (
          data.client_name === selectedStatus &&
          data.visa_provider === selectVisaProvider
        );
      } else if (selectedStatus) {
        return data.client_name === selectedStatus;
      } else if (selectVisaProvider) {
        return data.visa_provider === selectVisaProvider;
      }
      return true; // Return all data if no filter is selected
    });
  
    setFilteredData(filteredList);
  }, [currentList, selectedStatus, selectVisaProvider])

  const apiCall = () => {
    setCheckedItems({});
    updateData("");
    setIndex(1);
  };

  const [open, setOpen] = useState(false);
  const handleRemovePopUp = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setOpen(true);
    }
  };
  console.log("listData.......listData",listData)
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpen()}
        >
          <p>Renew</p>
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => {
            handleRemovePopUp();
          }}
        >
          <p>Remove</p>
        </button>
        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
        <FilterDropDown
          onChange={visaProviderFilter}
          title={"Visa Provider"}
          url={`/sadaad/visa-providers/`}
          token={token}
          selectedStatus={selectVisaProvider}
        />
        <FilterDropDown
          onChange={onChangeValue}
          title={"Client"}
          url={`/sadaad/clients`}
          token={token}
          selectedStatus={selectedStatus}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[3000px]">
            <div className="grid grid-cols-table-baladiya-renew gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
              {selectedStatus != "" && selectVisaProvider != "" ? (
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid grid-cols-table-baladiya-renew gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              filteredData.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.actual_profession || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_professions || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_provider || "-"}
                    />
                  </p>
                  <p className="overflow-x-hidden">
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.sponsor_id || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.baladiya_location || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.baladiya_apply_date || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.baladiya_issue_date || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.baladiya_expiry_date || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.baladiya_valid_days || "-"}
                    />
                  </p>
                  {selectedStatus === list.client_name &&
                  selectVisaProvider === list.visa_provider ? (
                    <div>
                      <input
                        key={list.employee_id} // Use a unique identifier as the key
                        type="checkbox"
                        checked={checkedItems[list.employee_id] || false}
                        onChange={(event) =>
                          handleCheckboxChange(event, list.employee_id, list)
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
      <Pagination />

      {Popup ? (
        <UpdatePopUp
          list={listData}
          data={Popup}
          setPopUp={setPopUp}
          onSuccess={apiCall}
          flage={false}
          updateData={updateData}
        />
      ) : (
        ""
      )}
      {open ? (
        <RemoveBaladiyaPopUp
          open={open}
          setOpen={setOpen}
          list={listData}
          updateData={updateData}
        />
      ) : (
        ""
      )}
    </>
  );
}
